import { useWatch } from 'react-hook-form';
import { ReactNode } from 'react';

export const StateFieldWatcher = ({
    fieldPrefix,
    children,
}: {
    fieldPrefix: 'primaryApplicant' | 'coApplicant';
    children: (state: string) => ReactNode;
}) => {
    const state = useWatch({
        name: [fieldPrefix, 'address.state'].join('.'),
    });

    return children(state as string);
};
